import { TOMATO_RED } from '../styles/theme';

const DEFAULT_PROPERTIES = {
  strokeColor: TOMATO_RED,
  strokeWeight: 3,
  fillColor: TOMATO_RED,
  fillOpacity: 0.2,
};

export const OPAQUE_STYLE = {
  strokeWeight: 0,
  fillColor: TOMATO_RED,
  fillOpacity: 0.4,
};

const wrapApiPolygon = (coordinates: object, properties?: object) => {
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: properties || DEFAULT_PROPERTIES,
        geometry: {
          type: 'MultiPolygon',
          coordinates,
        },
      },
    ],
  };
};

export default wrapApiPolygon;
